module.exports = __webpack_public_path__ + "img/yishenghuo.02e4fc0b.png";